var pug = require("!../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (cart) {pug_html = pug_html + "\u003Ca class=\"dropdown-toggle white-text\" data-toggle=\"dropdown\" href=\"#\"\u003E\u003Cdiv class=\"navbar-user-icon\"\u003E\u003Ci class=\"text-secondary fa-shopping-cart\"\u003E\u003C\u002Fi\u003E";
if (cart) {
if (cart.items.length) {
pug_html = pug_html + "\u003Cspan class=\"cart-items-number\"\u003E" + (pug.escape(null == (pug_interp = cart.items_number) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"navbar-user-text\"\u003E\u003Cdiv class=\"bold-small\"\u003EYour Cart\u003Cbr\u003E\u003C\u002Fdiv\u003E\u003Cspan\u003E ";
if (cart) {
if (cart.items.length) {
pug_html = pug_html + (pug.escape(null == (pug_interp = cart.items_number) ? "" : pug_interp)) + " items ";
}
else {
pug_html = pug_html + "No items";
}
}
else {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = "No items") ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003Ci class=\"fa-down-open-big\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003Cdiv class=\"dropdown-menu dropdown-menu-right dropdown-menu-cart\"\u003E\u003Cdiv class=\"cart-items disable-user-select\"\u003E";
if (cart) {
if (cart.items.length) {
pug_html = pug_html + "\u003Cdiv class=\"cart-items-header soft-gray-background\"\u003E\u003Ca href=\"\u002Fcart\"\u003EYou have " + (pug.escape(null == (pug_interp = cart.items_number + (cart.items_number > 1 ? " items" : " item")) ? "" : pug_interp)) + " in your basket\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"cart-items-holder\"\u003E";
// iterate cart.items
;(function(){
  var $$obj = cart.items;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var item = $$obj[pug_index0];
pug_html = pug_html + "\u003Ca" + (pug.attr("href", '/product/' + item.prod_id, true, true)) + "\u003E\u003Cdiv class=\"cart-items__image\"\u003E\u003Cdiv class=\"cart-items__item-count\"\u003E" + (pug.escape(null == (pug_interp = item.quantity) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
if (item.image_url) {
pug_html = pug_html + "\u003Cimg" + (" class=\"img-responsive\""+pug.attr("src", item.image_url, true, true)+pug.attr("alt", item.prod_name, true, true)) + "\u003E";
}
else {
pug_html = pug_html + "\u003Cimg" + (" class=\"img-responsive\""+" src=\"\u002Fassets\u002Fproduct-default-image.png\""+pug.attr("alt", item.prod_name, true, true)) + "\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"cart_items__name\"\u003E" + (pug.escape(null == (pug_interp = item.prod_name) ? "" : pug_interp)) + " \u003Cbr\u003E\u003Cspan class=\"text-primary\"\u003E€" + (pug.escape(null == (pug_interp = item.prod_final_price.toFixed(2)) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var item = $$obj[pug_index0];
pug_html = pug_html + "\u003Ca" + (pug.attr("href", '/product/' + item.prod_id, true, true)) + "\u003E\u003Cdiv class=\"cart-items__image\"\u003E\u003Cdiv class=\"cart-items__item-count\"\u003E" + (pug.escape(null == (pug_interp = item.quantity) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
if (item.image_url) {
pug_html = pug_html + "\u003Cimg" + (" class=\"img-responsive\""+pug.attr("src", item.image_url, true, true)+pug.attr("alt", item.prod_name, true, true)) + "\u003E";
}
else {
pug_html = pug_html + "\u003Cimg" + (" class=\"img-responsive\""+" src=\"\u002Fassets\u002Fproduct-default-image.png\""+pug.attr("alt", item.prod_name, true, true)) + "\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"cart_items__name\"\u003E" + (pug.escape(null == (pug_interp = item.prod_name) ? "" : pug_interp)) + " \u003Cbr\u003E\u003Cspan class=\"text-primary\"\u003E€" + (pug.escape(null == (pug_interp = item.prod_final_price.toFixed(2)) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Ca class=\"cart-items-footer soft-gray-background\" href=\"\u002Fcart\"\u003ETotal: €" + (pug.escape(null == (pug_interp = cart.total) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"cart-items-holder\"\u003E\u003Cp\u003E" + (pug.escape(null == (pug_interp = "There are no items in your cart") ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E";
}
}
else {
pug_html = pug_html + "\u003Cdiv class=\"cart-items-holder\"\u003E\u003Cp\u003E" + (pug.escape(null == (pug_interp = "There are no items in your cart") ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"cart-go-to-checkout\"\u003E";
if (cart) {
if (cart.items.length) {
pug_html = pug_html + "\u003Ca class=\"btn btn-default btn-block\" href=\"\u002Fcart\"\u003EView Cart and Checkout \u003Ci class=\"fa-right-arrow\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E";
}
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"cart" in locals_for_with?locals_for_with.cart:typeof cart!=="undefined"?cart:undefined));;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./~/pug-loader!./views/blocks/cart.pug
// module id = 31
// module chunks = 0